import React, { useEffect, useState } from "react";

import { Form, Formik } from "formik";

import Base from "../../../components/molecular/Base";
import BackButton from "../../../components/atomic/buttons/BackButton";
import ImageUpload from "../../../components/molecular/ImageUpload";
import { SubPackageSchema } from "../../../validations";
import TextInput from "../../../components/atomic/inputs/TextInput";
import PrimaryButton from "../../../components/atomic/buttons/PrimaryButton";
import SelectInput from "../../../components/atomic/inputs/SelectInput";
import {
  packageLabels,
  packageStatus,
  rating,
} from "../../../constants/constants";
import TextAreaInput from "../../../components/atomic/inputs/TextAreaInput";
import CustomTabs from "./CustomTabs";
import { getPackagesList } from "../../../services/packages";

const SubPackageForm = ({ initialValues, handleSubmit, loader, isUpdate }) => {
  const validationSchema = SubPackageSchema;
  const [packagesList, setPackagesList] = useState([
    { key: "", value: "Select" },
  ]);

  const getData = async () => {
    const res = await getPackagesList();
    const { data, status } = res;
    if (status === 200) {
      const packagesArr = data?.packages?.map((el) => {
        return {
          key: el._id ?? "--",
          value: el.package_name ?? "--",
        };
      });
      const combinedArr = [...packagesList, ...packagesArr];
      const uniqueArr = Array.from(new Set(combinedArr));
      setPackagesList([...uniqueArr]);
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Base>
      <div className=" p-4">
        <BackButton />
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, values, setFieldValue }) => {
            return (
              <div className=" w-full grid grid-cols-7 my-9 gap-x-10 bg-white border border-gray-200 rounded-xl">
                <div className="col-span-3 w-full  px-4 py-10">
                  <ImageUpload
                    aspectRatio={3 / 2}
                    image={values.image}
                    setFieldValue={setFieldValue}
                    name="image"
                    placeholder={"Add an image of 1024 x 650 Resolution"}
                    errors={errors}
                    touched={touched}
                  />
                  <div className="mt-8">
                    <Form>
                      <TextInput
                        id="name"
                        name="name"
                        placeholder="Honeymoon Package"
                        labelText="Sub Package Name"
                        type="text"
                        error={errors.name}
                        touched={touched.name}
                      />
                      <TextInput
                        id="days"
                        name="days"
                        placeholder="Days"
                        labelText="Number Of Days"
                        type="number"
                        error={errors.days}
                        touched={touched.days}
                        classes={"mt-3"}
                      />
                      <TextInput
                        id="nights"
                        name="nights"
                        placeholder="Nights"
                        labelText="Number Of Nights"
                        type="number"
                        error={errors.nights}
                        touched={touched.nights}
                        classes={"mt-3"}
                      />
                      <TextInput
                        id="price"
                        name="price"
                        placeholder="Original Price"
                        labelText="Original Price"
                        type="number"
                        error={errors.price}
                        touched={touched.price}
                        classes={"mt-3"}
                      />
                      <TextInput
                        id="discountPrice"
                        name="discountPrice"
                        placeholder="Discount Price"
                        labelText="Discount Price"
                        type="number"
                        error={errors.discountPrice}
                        touched={touched.discountPrice}
                        classes={"mt-3"}
                      />
                      <SelectInput
                        id="label"
                        name="label"
                        placeholder="Package Label"
                        labelText="Package Label"
                        error={errors.label}
                        touched={touched.label}
                        options={packageLabels}
                        classes={"mt-3"}
                      />
                      <SelectInput
                        id="status"
                        name="status"
                        placeholder="Package Status"
                        labelText="Package Status"
                        error={errors.status}
                        touched={touched.status}
                        options={packageStatus}
                        classes={"mt-3"}
                      />
                      <SelectInput
                        id="package_id"
                        name="package_id"
                        placeholder="Package "
                        labelText="Package Name"
                        error={errors.package_id}
                        touched={touched.package_id}
                        options={packagesList}
                        classes={"mt-3"}
                      />
                      <SelectInput
                        id="rating"
                        name="rating"
                        placeholder="Rating "
                        labelText="Rating"
                        error={errors.rating}
                        touched={touched.rating}
                        options={rating}
                        classes={"mt-3"}
                      />
                      <TextAreaInput
                        id="description"
                        name="description"
                        placeholder="Description"
                        labelText="Description"
                        error={errors.description}
                        touched={touched.description}
                        classes={"mt-3"}
                      />
                      <div className="mt-4">
                        <PrimaryButton
                          width={"w-full"}
                          buttonText={
                            isUpdate ? "Update Package" : "Add Package"
                          }
                          type={"submit"}
                          loader={loader}
                        />
                      </div>
                    </Form>
                  </div>
                </div>
                <div className="col-span-4 px-4">
                  <CustomTabs
                    values={values}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                    isUpdate={isUpdate}
                  />
                </div>
              </div>
            );
          }}
        </Formik>
      </div>
    </Base>
  );
};

export default SubPackageForm;
